const global = {
  local_url: '//apistudy.t.eoffcn.com',
  test_url: '//apistudy.t.eoffcn.com',
  online_url: '//apistudy.eoffcn.com',
  online_url2: '//apistudy2.eoffcn.com',
  shop_local: '//shop.t.eoffcn.com',
  shop_test_url: '//shop.t.eoffcn.com',
  shop_online_url: '//shop.eoffcn.com',
  record_local: '//api.t.eoffcn.com',
  record_test_url: '//api.t.eoffcn.com',
  record_online_url: '//api.eoffcn.com'
}
export default {
  global
}



// WEBPACK FOOTER //
// ./src/global/index.js